module.exports = __webpack_public_path__ + "img/download-all2.567341e6.svg";